import {useSlot} from '../../hooks/useSlot';

export function Slot({name = 'default', children}: any) {
  useSlot(name)(children);
  return null;
}
